import { lazy, Suspense } from "react";
import Loader from "./Loader";

const LazyLoader = (importFunction) => {
  const Component = lazy(importFunction);
  return (props) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};
export default LazyLoader;
